import axios from 'axios';

const BASE_URL = 'https://api.coingecko.com/api/v3';

export async function getCoinList() {
  const response = await axios.get(`${BASE_URL}/coins/markets`, {
    params: {
      vs_currency: 'usd',
      order: 'market_cap_desc',
      per_page: 50,
      page: 1
    }

  });
  return response.data;
}

export async function getCoinDetail(id) {
  const response = await axios.get(`${BASE_URL}/coins/${id}`); 
  return response.data;
}

export async function getCoinChart(id, days = 7) {
  const response = await axios.get(`${BASE_URL}/coins/${id}/market_chart`, {
    params: {
      vs_currency: 'usd',
      days: days
    }
  });
  return response.data;
}